"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledBasicFilter = exports.StyledBasicFilterToggleButtons = exports.StyledBasicFilterToggleButton = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const controls_1 = require("../controls");
const helpers_1 = require("../helpers");
const StackView_1 = require("../StackView");
const BASIC_FILTER_TOGGLE_BUTTON_Z_INDEX_DEFAULT = 1;
exports.StyledBasicFilterToggleButton = (0, styled_components_1.default)(controls_1.ToggleButton) `
    position: relative; // to be able change z-index

    ${({ isToggled, disabled }) => isToggled && !disabled
    ? (0, styled_components_1.css) `
                  z-index: ${BASIC_FILTER_TOGGLE_BUTTON_Z_INDEX_DEFAULT + 1};
              `
    : (0, styled_components_1.css) `
                  z-index: ${BASIC_FILTER_TOGGLE_BUTTON_Z_INDEX_DEFAULT};
              `}
`;
exports.StyledBasicFilterToggleButtons = (0, styled_components_1.default)(StackView_1.StackView) `
    ${exports.StyledBasicFilterToggleButton}:not(:first-child) {
        margin-left: -1px;
    }
`;
exports.StyledBasicFilter = styled_components_1.default.div `
    display: inline-flex;
    height: ${helpers_1.SPACING_XXL};
    padding: 0 ${helpers_1.SPACING_M};
    box-sizing: border-box;

    ${exports.StyledBasicFilterToggleButton}:not(:first-of-type) {
        margin-left: calc(-1 * ${helpers_1.BASE_BORDER_WIDTH});
    }
`;
//# sourceMappingURL=BasicFilter.styles.js.map